import React, { useEffect, useState, useCallback } from "react";
import { Spin, Card } from "antd";
import { fetchAttendance } from "src/APIService/store";
import { ProductListingStyled } from "./styled";
import TableAttendance from "./TableAttendance";
import FilterBar from "./FilterBar";
import useAPILoading from "hooks/useAPILoading";
import { exportAttendanceCSV } from "./ExportCSV";

const AttendanceLog = () => {
  const [attendanceData, setAttendanceData] = useState([]);
  const [getAttendance, loading] = useAPILoading(fetchAttendance);
  const [stores, setStores] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [dateRange, setDateRange] = useState(null);
  const [selectedMerchant, setSelectedMerchant] = useState("");

  const getAttendanceList = useCallback(
    async (merchantName = selectedMerchant, page = currentPage, size = pageSize) => {
      try {
        const data = await getAttendance(merchantName, dateRange, page, size);
        setAttendanceData(data.attendances || []);
        setTotalRecords(data.total || 0);

        if (!stores.length) {
          const uniqueStores = [
            ...new Set((data.attendances || []).map((item) => item.staff_merchant_name)),
          ].map((name) => ({ value: name, label: name }));
          setStores(uniqueStores);
        }
      } catch (error) {
        console.error("Failed to fetch attendance", error);
      }
    },
    [selectedMerchant, currentPage, pageSize, dateRange, stores.length, getAttendance]
  );

  useEffect(() => {
    getAttendanceList();
  }, [getAttendanceList]);

  const handleSubmit = (values) => {
    setSelectedMerchant(values.storeName || "");
    setDateRange(values.dateRange || null);
    setCurrentPage(1);
  };

  const handleExportCSV = () => {
    exportAttendanceCSV({
      selectedMerchant,
      dateRange,
      fetchAttendance,
    });
  };

  return (
    <ProductListingStyled>
      <Card title="Attendance Log" className="product-listing-card">
        {loading ? (
          <Spin />
        ) : (
          <>
            <FilterBar
              stores={stores}
              loading={loading}
              onSubmit={handleSubmit}
              onDateRangeChange={setDateRange}
              onExport={handleExportCSV}
            />
            <div style={{ padding: 20 }}>
              <TableAttendance
                data={attendanceData}
                loading={loading}
                pagination={{
                  current: currentPage,
                  pageSize,
                  total: totalRecords,
                  showSizeChanger: true,
                  onChange: (page, size) => {
                    setCurrentPage(page);
                    setPageSize(size);
                  },
                }}
              />
            </div>
          </>
        )}
      </Card>
    </ProductListingStyled>
  );
};

export default AttendanceLog;
